import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { RefreshService } from './refresh.service';

// Ресты-источники автозаполнения полей (field.autofill.url — заводится в
// админке, см. autofill.util.ts). На один и тот же рест ссылается много полей
// и несколько страниц, поэтому ответ кэшируется: один запрос на адрес + iin,
// в том числе пока он ещё не завершился. Ошибку не кэшируем — следующий вызов
// идёт на бэк заново. Сброс — pull-to-refresh (RefreshService).
@Injectable({
  providedIn: 'root'
})
export class AutofillSourceService {
  private apiUrl = environment.api_url + environment.api_version;
  private cache = new Map<string, Observable<any>>();

  constructor(private http: HttpClient, private authService: AuthService, refreshService: RefreshService) {
    refreshService.refresh$.subscribe(() => this.cache.clear());
  }

  // url — только относительный путь своего API ("/constructor/founders"):
  // запрос уходит с токеном и iin пользователя, наружу их отдавать нельзя.
  // {iin} и {bin} в адресе заменяются данными текущего пользователя.
  get<T = any>(url: string): Observable<T> {
    const path = (url || '').trim();
    if (!path.startsWith('/') || path.startsWith('//') || path.includes('://')) {
      return throwError(new Error(`Autofill url must be a relative API path: ${url}`));
    }
    const iin = this.authService.user?.iin || '';
    const resolved = path
      .replace(/\{iin\}/g, encodeURIComponent(iin))
      .replace(/\{bin\}/g, encodeURIComponent(this.authService.userBin || ''));
    const key = `${iin}|${resolved}`;
    const cached = this.cache.get(key);
    if (cached) {
      return cached;
    }
    const request$ = this.http.get<T>(this.apiUrl + resolved).pipe(
    // const request$ = this.http.get<T>(this.apiUrl + resolved, {
    //   headers: new HttpHeaders({ iin })
    // }).pipe(
      catchError(err => {
        if (this.cache.get(key) === request$) {
          this.cache.delete(key);
        }
        return throwError(err);
      }),
      shareReplay({ bufferSize: 1, refCount: false })
    );
    this.cache.set(key, request$);
    return request$;
  }

  invalidate(url: string): void {
    Array.from(this.cache.keys())
      .filter(key => key.slice(key.indexOf('|') + 1) === url)
      .forEach(key => this.cache.delete(key));
  }
}
